import { Helpers } from '../../helpers';
import { ILifespanProjection } from '../../interfaces/ilifespan-projection';
import { WaterWell } from '../water-well';

export class LifespanProjectionBase {
  LifespanProjectionId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  WaterWells_LifespanProjection?: Array<WaterWell> | null;

  constructor(item?: ILifespanProjection) {
    if (item) {

      this.LifespanProjectionId = item.LifespanProjectionId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.WaterWells_LifespanProjection = Helpers.createClassArray(WaterWell, item.WaterWells_LifespanProjection);
    }
  }
}